import { DFPModal } from "@/components/modals/dfp-modal";
import { Form, Input } from "antd";

interface Props {
	open: boolean;
	onClose: () => void;
	credentials: {
		username: string;
		password: string;
	};
	setCredentials: (creds: { username: string; password: string }) => void;
	onSave: () => void;
	saving: boolean;
}

/**
 * Modal component for managing Service Channel credentials
 */
export const CredentialsModal = ({
	open,
	onClose,
	credentials,
	setCredentials,
	onSave,
	saving,
}: Props) => {
	return (
		<DFPModal
			open={open}
			title="Service Channel Credentials"
			onOk={onSave}
			onCancel={onClose}
			confirmLoading={saving}
		>
			<Form layout="vertical">
				{/* Username field */}
				<Form.Item
					label="Username"
					required
					tooltip="Your Service Channel username"
				>
					<Input
						value={credentials.username}
						onChange={(e) =>
							setCredentials({
								...credentials,
								username: e.target.value,
							})
						}
						placeholder="Enter username"
					/>
				</Form.Item>

				{/* Password field */}
				<Form.Item
					label="Password"
					required
					tooltip="Your Service Channel password"
				>
					<Input.Password
						value={credentials.password}
						onChange={(e) =>
							setCredentials({
								...credentials,
								password: e.target.value,
							})
						}
						placeholder="Enter password"
					/>
				</Form.Item>
			</Form>
		</DFPModal>
	);
};
